import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from './main-layout.component';
import { AuthGuard } from '@app-core/guards/auth/auth.guard';
import { UserSettingsComponent } from '@shared/components/user-settings/user-settings.component';
import { ActiveDeploymentGuard } from '@app-core/guards/active-deployment.guard';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [ActiveDeploymentGuard, AuthGuard],
    data: { roles: ['Admin', 'Employee'] },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'referrals',
      },
      {
        path: 'settings',
        pathMatch: 'full',
        component: UserSettingsComponent,
      },
      {
        path: 'referrals',
        loadChildren: () =>
          import('../../main/referrals/referrals.module').then(
            (m) => m.ReferralsModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainLayoutRoutingModule {}
